var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoicePaid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.762,
    height: 24.493,
    viewBox: "0 0 24.762 24.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38386",
    "data-name": "Group 38386",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13383",
    "data-name": "Rectangle 13383",
    width: 24.493,
    height: 24.493,
    transform: "translate(0.001 0)",
    fill: "#4a95cd",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38123",
    "data-name": "Group 38123",
    transform: "translate(0 0.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27780",
    "data-name": "Path 27780",
    d: "M251.061,144.253h1.226a.234.234,0,0,0,.235-.235v-1.226A2.933,2.933,0,0,0,255,140.261a2.874,2.874,0,0,0-2.87-3.157h-.913a1.2,1.2,0,0,1-1.2-1.331,1.224,1.224,0,0,1,1.252-1.07h1.07a.839.839,0,0,1,.809.652.251.251,0,0,0,.235.183h1.226a.227.227,0,0,0,.235-.261,2.513,2.513,0,0,0-2.348-2.244v-1.2a.234.234,0,0,0-.235-.235h-1.2a.234.234,0,0,0-.235.235v1.2a2.894,2.894,0,0,0-2.479,3.131,2.974,2.974,0,0,0,3,2.583h.783a1.2,1.2,0,0,1,1.2,1.331,1.224,1.224,0,0,1-1.252,1.07h-1.1a.838.838,0,0,1-.809-.652.251.251,0,0,0-.235-.183h-1.226a.227.227,0,0,0-.235.261,2.513,2.513,0,0,0,2.348,2.244v1.2a.234.234,0,0,0,.235.235Z",
    transform: "translate(-240.676 -126.928)",
    fill: "#4a95cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27781",
    "data-name": "Path 27781",
    d: "M94.983,51.424a9.08,9.08,0,1,1,9.08-9.08,10.08,10.08,0,0,1-.209,2.009,1.273,1.273,0,0,1,.313-.026,5.643,5.643,0,0,1,1.618.235,10.322,10.322,0,0,0,.209-2.218A11,11,0,1,0,94.983,53.329a10.681,10.681,0,0,0,4.2-.835,5.309,5.309,0,0,1-.574-1.853,8.776,8.776,0,0,1-3.627.783Z",
    transform: "translate(-83.998 -31.36)",
    fill: "#4a95cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27782",
    "data-name": "Path 27782",
    d: "M421.844,330.4a4.618,4.618,0,1,0,4.592,4.618A4.572,4.572,0,0,0,421.844,330.4Zm2.009,3.731-2.113,2.5a.446.446,0,0,1-.679,0l-1.2-1.435a.463.463,0,0,1,.7-.6l.861,1.018,1.748-2.087a.481.481,0,0,1,.652-.052A.512.512,0,0,1,423.854,334.131Z",
    transform: "translate(-401.675 -316.467)",
    fill: "#4a95cd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicePaid);
export default __webpack_public_path__ + "static/media/invoicePaid.6712ab5096736fdf9339bee33e49f00f.svg";
export { ForwardRef as ReactComponent };